import { render } from "./Person-List-Item-Birthday.vue?vue&type=template&id=437ef466&scoped=true"
import script from "./Person-List-Item-Birthday.vue?vue&type=script&lang=js"
export * from "./Person-List-Item-Birthday.vue?vue&type=script&lang=js"

import "./Person-List-Item-Birthday.vue?vue&type=style&index=0&id=437ef466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437ef466"]])

export default __exports__